import { useCallback, useEffect, useState } from "react"

import { OrderWorkflowExecutionSearchHit } from "lib/types/generated/graphql"

const DEFAULT_INTERVAL_MS = 3000
const DEFAULT_KICK_DURATION_MS = 15000

const isActive = (hit: OrderWorkflowExecutionSearchHit) =>
  !hit.completed && !hit.failed

export const useAutoRefreshActiveExecutions = (
  hits: OrderWorkflowExecutionSearchHit[],
  refresh: () => void,
  intervalMs: number = DEFAULT_INTERVAL_MS
) => {
  const [isKicked, setIsKicked] = useState(false)
  const hasActive = hits.some(isActive)
  const shouldPoll = hasActive || isKicked

  useEffect(() => {
    if (!shouldPoll) return
    const handle = setInterval(refresh, intervalMs)
    return () => clearInterval(handle)
  }, [shouldPoll, refresh, intervalMs])

  useEffect(() => {
    if (!isKicked) return
    const handle = setTimeout(() => setIsKicked(false), DEFAULT_KICK_DURATION_MS)
    return () => clearTimeout(handle)
  }, [isKicked])

  const kickPoll = useCallback(() => {
    setIsKicked(true)
  }, [])

  return { kickPoll }
}
